export enum EUserNotificationCode {
    SOS = 1,
    Inactivity = 2,
}
